import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FileCopySvg } from "../../../svgFiles/FileCopySvg";

const CopyToClipboard = ({ value, className }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipText, setTooltipText] = useState("Click to copy");

  const handleCopy = () => {
    if(!value) return;
    navigator.clipboard.writeText(value).then(() => {
      setTooltipText("Copied to clipboard!");
      setShowTooltip(true);

      // Reset after 1.5s
      setTimeout(() => {
        setShowTooltip(false);
      }, 500);
    });
  };

  return (
    <OverlayTrigger
      placement="top"
      show={showTooltip}
      overlay={<Tooltip id={`tooltip-${value}`}>{tooltipText}</Tooltip>}
    >
      <span
        onClick={handleCopy}
        style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
      >
        <FileCopySvg className={className}/>
      </span>
    </OverlayTrigger>
  );
};

export default CopyToClipboard;
